import { useQuery } from '@tanstack/react-query';
import { getNotificationPreferences } from '../service';

function useNotificationPreferences() {
    const query = useQuery({
        queryKey: ['property-manager', 'notification-preferences'],
        queryFn: () => getNotificationPreferences(),
        enabled: true,
    });

    return query;
}

export { useNotificationPreferences };
